import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { CUSTOMER_QUERY_KEYS } from "common/constants";
import { get } from "common/helpers/HTTP";
import type { Invitation } from "common/types";

async function getInvitation(inviteToken: string): Promise<Invitation> {
  return (await get(`invites/${inviteToken}`)).invite;
}

export default function useInvitation(inviteToken: string) {
  const {
    data: invitation,
    isLoading: isLoadingInvitation,
    error: invitationError,
    refetch: refetchInvitation,
  } = useQuery({
    queryKey: CUSTOMER_QUERY_KEYS.invitationsKeys.details(inviteToken),
    queryFn: () => getInvitation(inviteToken),
    placeholderData: keepPreviousData,
    enabled: !!inviteToken,
  });

  return {
    invitation,
    isLoadingInvitation,
    invitationError,
    refetchInvitation,
  };
}
